import { RankingManager } from '../../../fragments/admin/ranking/RankingManager'

const AdminRanking = () => {
    return (
        <main>
            <RankingManager />
        </main>
    )
}
export default AdminRanking
